import React, { useEffect } from 'react';
import { API, Auth } from 'aws-amplify';
import { useParams } from 'react-router';
import { RootState, useDispatch, useSelector } from 'src/store';
import { buttonsReset } from 'src/store/modules/buttons';
import { editUserCompany } from 'src/store/modules/client';
import { editTextReset } from 'src/store/modules/editText';
import { imageReset } from 'src/store/modules/imageUpload';
import { trackingReset } from 'src/store/modules/trackings';
import { changeEnter } from 'src/utils/changeEnter';
import { getFontURL } from 'src/utils/getFontUrl';
import setInitValue from 'src/utils/setInitValue';
import { initTrackingValues } from '../TemplateTracking/TransparentBottomSheetTracking';

const initViewValues = {
  bg: 'color',
  bgOpacity: { bgDimmed: 30 },
  bgColor: { background: '#ffffff' },
  radius: { background: 10, button: 5, never_show_button: 0 },
  deeplink: { background: 'https://www.inappmessage.com/' },
  text: {
    title: 'Recommended Items',
    sub_title:
      'If you click "like" for the product, I recommend the product that goes well with it'
  },
  fontSize: { title: 1.625, sub_title: 1 },
  fontWeight: { title: 600, sub_title: 400 },
  color: { title: '#000000', sub_title: '#000000' },
  fontFamily: { title: 'Pretendard', sub_title: 'Pretendard' },
  textAlign: {
    title: 'center',
    sub_title: 'center'
  },
  btnText: {
    button: 'open now',
    never_show_button: 'close'
  },
  btnTextAlign: {
    button: 'center',
    never_show_button: 'center'
  },
  btnFontSize: {
    button: 0.9375,
    never_show_button: 0.875
  },
  btnFontWeight: {
    button: 500,
    never_show_button: 400
  },
  btnColor: {
    button: '#000000',
    never_show_button: '#000000'
  },
  btnBgColorR: {
    button: 149,
    never_show_button: 255
  },
  btnBgColorG: {
    button: 131,
    never_show_button: 255
  },
  btnBgColorB: {
    button: 255,
    never_show_button: 255
  },
  btnBgColorA: {
    button: 1,
    never_show_button: 1
  },
  btnFontFamily: {
    button: 'Pretendard',
    never_show_button: 'Pretendard'
  },
  btnAgain: {
    type: 'none',
    never_show_button: "don't show"
  },
  button1: {
    button: [],
    never_show_button: []
  },
  button2: {
    button: [],
    never_show_button: []
  }
};
const BasicBottomSheet = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    async function getUserId() {
      try {
        const current = await Auth.currentUserInfo();
        dispatch(editUserCompany(current.attributes['custom:Company']));
      } catch (error) {
        console.log('error');
      }
    }
    getUserId();
  }, []);

  const bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  const radius = useSelector((state: RootState) => state.imageUpload.radius);
  const text = useSelector((state: RootState) => state.editText.text);
  const fontSize = useSelector((state: RootState) => state.editText.fontSize);
  const fontWeight = useSelector(
    (state: RootState) => state.editText.fontWeight
  );
  const color = useSelector((state: RootState) => state.editText.color);
  const fontFamily = useSelector(
    (state: RootState) => state.editText.fontFamily
  );
  const textAlign = useSelector((state: RootState) => state.editText.textAlign);
  const bgOpacity = useSelector(
    (state: RootState) => state.imageUpload.bgImageBlur
  );
  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );

  const backgroundDimmed = bgOpacity?.bgDimmed / 100;
  const displayValue = backgroundDimmed >= 0.01 ? backgroundDimmed : 0.3;

  const titleFontURL = getFontURL(fontFamily?.title);
  const subTitleFontURL = getFontURL(fontFamily?.sub_title);
  const btnFontURL = getFontURL(fontFamily?.button);
  const neverShowBtnFontURL = getFontURL(fontFamily?.never_show_button);

  const style = `
    @font-face {
      font-family: "title";
      src: url(${titleFontURL});
    }
    @font-face {
      font-family: "subTitle";
      src: url(${subTitleFontURL});
    }
    @font-face {
      font-family: "btn";
      src: url(${btnFontURL});
    }
    @font-face {
      font-family: "neverShowBtn";
      src: url(${neverShowBtnFontURL});
    }

    .root-view {
      width: 100%;
      height: 100%;
      position: relative;
      background: none;
      overflow: hidden;
      display: flex;
      align-items: flex-end;
    }

    .background {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      background: rgba(0, 0, 0, ${displayValue});
    }

    .outer-wrapper {
      position: relative;
      width: 100%;
      height: fit-content;
      display: flex;
      flex-direction: column;
      align-items: center;
      
    }

    .modal-wrapper {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: auto;
      border-radius: ${radius?.background}px ${radius?.background}px 0 0;
      padding: 36px 15px 24px 15px;
      background-color: ${bgColor?.background};
      gap: 16px;
    }

    .contents-box {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      gap: 5px;
    }

    .contents-box .title,
    .contents-box .sub-title {
      width: 100%;
      min-height: 48px;
      display: flex;
      align-items: center;
    }

    .title p {
      width: 100%;
      font-size: ${fontSize?.title}rem;
      text-align: ${textAlign?.title};
      font-weight: ${fontWeight?.title};
      color: ${color?.title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.title
        )
          ? fontFamily.title
          : 'title'
      };
    }

    .sub-title p {
      width: 100%;
      font-size: ${fontSize?.sub_title}rem;
      font-weight: ${fontWeight?.sub_title};
      line-height: 1.35;
      text-align: ${textAlign?.sub_title};
      color: ${color?.sub_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.sub_title
        )
          ? fontFamily.sub_title
          : 'subTitle'
      };
    }

    .btn-wrapper {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    .btn-inner {
      width: 100%;
      height: 52px;
      font-size: ${btnFontSize?.button}rem;
      font-weight: ${btnFontWeight?.button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.button
        )
          ? btnFontFamily.button
          : 'btn'
      };
      line-height: 52px;
      color: ${btnColor?.button};
      background-color: rgba(${btnBgColorR?.button}, ${btnBgColorG?.button}, ${
    btnBgColorB?.button
  }, ${btnBgColorA?.button});
      border-radius: ${radius?.button}px;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: 0 5px;
      border: none;
    }

    .btn-close {
      width: 100%;
      height: 52px;
      font-size: ${btnFontSize?.never_show_button}rem;
      font-weight: ${btnFontWeight?.never_show_button};
      line-height: 52px;
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.never_show_button
        )
          ? btnFontFamily.never_show_button
          : 'neverShowBtn'
      };
      color: ${btnColor?.never_show_button};
      background-color: rgba(${btnBgColorR?.never_show_button}, ${
    btnBgColorG?.never_show_button
  }, ${btnBgColorB?.never_show_button}, ${btnBgColorA?.never_show_button});
      text-align: center;
      border-radius: ${radius?.never_show_button}px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: 0 5px;
    }

   
  `;
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    async function onLoad() {
      try {
        if (id) {
          const { customValues } = await API.get(
            'iam-editor',
            `/templates/${id}`,
            ''
          );
          setInitValue(dispatch, customValues);
        }
      } catch (error) {}
    }
    setInitValue(dispatch, { ...initViewValues, ...initTrackingValues });

    onLoad();

    return () => {
      dispatch(buttonsReset());
      dispatch(editTextReset());
      dispatch(imageReset());
      dispatch(trackingReset());
    };
  }, []);
  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root-view">
        <div className="background" />
        <div className="outer-wrapper">
          <div className="modal-wrapper">
            <div className="contents-box">
              <div className="title">
                <p>{changeEnter(text?.title)}</p>
              </div>
              <div className="sub-title">
                <p>{changeEnter(text?.sub_title)}</p>
              </div>
            </div>
            <div className="btn-wrapper">
              <button className="btn-inner">{btnText?.button}</button>
              <div className="btn-close">{btnText?.never_show_button}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BasicBottomSheet;
